import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container p-0 m-0" }
const _hoisted_2 = {
  key: 0,
  "aria-label": "Voortgang van het formulier",
  class: "visually-hidden"
}
const _hoisted_3 = { class: "stappen" }
const _hoisted_4 = ["aria-current"]
const _hoisted_5 = { class: "visually-hidden" }
const _hoisted_6 = {
  key: 1,
  ref: "foutenSamenvatting",
  tabindex: "-1",
  role: "alert",
  class: "alert alert-danger mt-3"
}
const _hoisted_7 = { class: "h6" }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = ["href", "onClick"]
const _hoisted_10 = { class: "d-flex justify-content-end mb-2" }
const _hoisted_11 = ["hidden"]
const _hoisted_12 = {
  key: 2,
  class: "alert alert-warning alert-dismissible fade show",
  role: "alert"
}
const _hoisted_13 = { class: "d-flex justify-content-end mb-2" }
const _hoisted_14 = {
  class: "text-muted",
  style: {"font-size":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormElement = _resolveComponent("FormElement")!
  const _component_SReCaptcha = _resolveComponent("SReCaptcha")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.paginaTitels.length > 1)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
          _createElementVNode("ol", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginaTitels, (titel, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: i,
                "aria-current": i === Number(_ctx.internalPageIndex) ? 'step' : undefined,
                class: _normalizeClass({ 'stap-actief': i === Number(_ctx.internalPageIndex) })
              }, [
                _createElementVNode("span", _hoisted_5, "Stap " + _toDisplayString(i + 1) + " van " + _toDisplayString(_ctx.paginaTitels.length) + ": ", 1),
                _createTextVNode(_toDisplayString(titel), 1)
              ], 10, _hoisted_4))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h1", {
      ref: "paginaKop",
      tabindex: "-1",
      class: "visually-hidden"
    }, _toDisplayString(_ctx.kopTekst), 513),
    (_ctx.foutenLijst.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("h2", _hoisted_7, "Er " + _toDisplayString(_ctx.foutenLijst.length === 1 ? 'is 1 veld' : 'zijn ' + _ctx.foutenLijst.length + ' velden') + " niet goed ingevuld", 1),
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.foutenLijst, (fout) => {
              return (_openBlock(), _createElementBlock("li", {
                key: fout.id
              }, [
                _createElementVNode("a", {
                  href: '#' + fout.id,
                  onClick: _withModifiers(($event: any) => (_ctx.springNaarVeld(fout.id)), ["prevent"])
                }, _toDisplayString(fout.label), 9, _hoisted_9)
              ]))
            }), 128))
          ])
        ], 512))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      ref: "myForm",
      class: _normalizeClass([{ 'was-validated': _ctx.wasValidated }, "row g-3 needs-validation ms-1 mt-2"]),
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleNextOrSubmit && _ctx.handleNextOrSubmit(...args)), ["prevent"])),
      novalidate: ""
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (element, index) => {
        return (_openBlock(), _createBlock(_component_FormElement, {
          element: element,
          pageIndex: Number(_ctx.internalPageIndex),
          key: index,
          targetId: 'element-' + index,
          elementIndex: index,
          lang: _ctx.lang,
          formData: _ctx.formData,
          formVersion: _ctx.formVersion,
          wasValidated: _ctx.wasValidated,
          onElementChanged: _ctx.elementChanged,
          required: "",
          hidden: _ctx.isHidden(element),
          defaultLabelPosition: _ctx.formStructure && _ctx.formStructure.defaultLabelPosition
        }, null, 8, ["element", "pageIndex", "targetId", "elementIndex", "lang", "formData", "formVersion", "wasValidated", "onElementChanged", "hidden", "defaultLabelPosition"]))
      }), 128)),
      (_ctx.isLastPage && !_ctx.formStructure.hideCaptcha)
        ? (_openBlock(), _createBlock(_component_SReCaptcha, {
            key: 0,
            onOnRecaptchaTokenResponse: _ctx.onRecaptchaTokenResponse,
            class: "mb-3"
          }, null, 8, ["onOnRecaptchaTokenResponse"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary ms-1",
          hidden: _ctx.internalPageIndex == 0,
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["stop"]))
        }, "< Vorige", 8, _hoisted_11),
        _createElementVNode("button", {
          type: "submit",
          class: _normalizeClass([_ctx.isLastPageOfForm(_ctx.internalPageIndex) ? 'btn-primary' : 'btn-secondary', "btn ms-1"])
        }, _toDisplayString(_ctx.isLastPage ? 'Verzenden' : 'Volgende >'), 3)
      ])
    ], 34),
    (_ctx.alertVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createTextVNode(_toDisplayString(_ctx.alertMessage) + " ", 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.alertVisible = false)),
            "aria-label": "Melding sluiten"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("small", _hoisted_14, "v" + _toDisplayString(_ctx.formVersion), 1)
    ])
  ]))
}